// extracted by mini-css-extract-plugin
module.exports = {"uploadImg":"upload_uploadImg__s3G7a","guestAvatarFit":"upload_guestAvatarFit__8Uy0s"};